import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: 'CardamomAuction',
    // path: '/app',
    cluster: 'mt1',
    forceTLS: true,
    encrypted: false,
    wsHost: 'cardamomauction.com',
    wsPort: 6001,
    wssPort: 6001,
    disableStats: true,
    enabledTransports: ['ws','wss'],
    disabledTransports: ['sockjs', 'xhr_polling', 'xhr_streaming'],
    auth: {
        headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            'X-Requested-With': 'XMLHttpRequest',
        },
    },
});

// // Testing Channels & Events & Connections
// window.Echo.channel("delivery").listen("PackageSent", (event) => {
//     console.log('PackageSent event received:', event);
// });

// Connection state logging
window.Echo.connector.pusher.connection.bind('state_change', function(states) {
    console.log('Pusher connection state changed:', states);
});

window.Echo.connector.pusher.connection.bind('connected', function() {
    console.log('Successfully connected to Pusher/Reverb');
});

window.Echo.connector.pusher.connection.bind('error', function(err) {
    console.error('Pusher/Reverb connection error:', err);
});

// Additional debugging
window.Echo.connector.pusher.connection.bind('disconnected', function() {
    console.log('Disconnected from Pusher/Reverb');
});

window.Echo.connector.pusher.connection.bind('connecting', function() {
    console.log('Attempting to connect to Pusher/Reverb');
});
